<template>
  <v-card class="text-center" outlined tile>
    <Paleta v-if="Articulo[0].UniVenta === `M2`" class="ml-1 mr-1" />
    <Paquete v-if="Articulo[0].UniVenta !== `M2`" class="ml-1 mr-1" />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { Paleta, Paquete } from "../Icons";

export default {
  components: { Paleta, Paquete },
  computed: {
    ...mapState(["Articulo"]),
  },
};
</script>

<style></style>
